export default __webpack_public_path__ + "static/media/aequalis11.fc13e9f7.pdf";